import React, { useState, useEffect } from "react";
import { DateTime } from "luxon";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

export default function DateSelector({ action, from, to }) {
    const [IsShowing, setIsShowing] = useState(false);
    const [StartDate, setStartDate] = useState(new Date());
    const [EndDate, setEndDate] = useState(new Date(new Date().setDate(new Date().getDate() - 30)));
    const [RangeView, setRangeView] = useState("");

    function handleClose() {
        setIsShowing(false);
    }

    const handleSelect = (ranges) => {
        setStartDate(ranges.selection.startDate);
        setEndDate(ranges.selection.endDate);

        const startD = DateTime.fromJSDate(ranges.selection.endDate);
        const endD = DateTime.fromJSDate(ranges.selection.startDate);

        setRangeView(`${endD.toFormat("dd MMMM yyyy")} - ${startD.toFormat("dd MMMM yyyy")}`);

        // console.log(ranges)
        // {
        //   selection: {
        //     startDate: [native Date Object],
        //     endDate: [native Date Object],
        //   }
        // }
    };

    return (
        <>
            <div className="input-group input-group-sm" style={{ width: 310 }}>
                <input type="text" name="table_search" className="form-control float-right" autoComplete="off" onClick={() => setIsShowing(true)} placeholder="Select Date Range" value={RangeView} style={{ cursor: "pointer" }} />
                <div className="input-group-append">
                    <button
                        type="submit"
                        className="btn btn-default"
                        onClick={() => {
                            action("", "");
                            setRangeView("");
                            from("");
                            to("");
                        }}
                    >
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
            </div>
            {IsShowing && (
                <div className={`modal fade show`} id="modal-default" style={{ display: "block", paddingRight: 17 }} aria-modal="true" role="dialog">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{RangeView}</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => handleClose()}>
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body" style={{ maxHeight: "83vh", overflowY: "auto" }}>
                                <div style={{ width: "100%", textAlign: "center" }}>
                                    <DateRangePicker
                                        ranges={[
                                            {
                                                startDate: StartDate,
                                                endDate: EndDate,
                                                key: "selection",
                                            },
                                        ]}
                                        rangeColors={["#111111"]}
                                        months={2}
                                        direction="horizontal"
                                        onChange={handleSelect}
                                    />
                                </div>
                                <button
                                    type="button"
                                    className="btn btn-dark float-right mt-2"
                                    onClick={(e) => {
                                        from((oldTime) => DateTime.fromJSDate(StartDate).ts);
                                        to((oldTile) => DateTime.fromJSDate(EndDate).ts);
                                        action();
                                        handleClose();
                                    }}
                                >
                                    Apply Now
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
